module.exports = __webpack_public_path__ + "static/img/4.32deb31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/4.png
// module id = +0Cj
// module chunks = 0